import { render } from "./MapComponent.vue?vue&type=template&id=7f226c31"
import script from "./MapComponent.vue?vue&type=script&lang=js"
export * from "./MapComponent.vue?vue&type=script&lang=js"

import "./MapComponent.vue?vue&type=style&index=0&id=7f226c31&lang=scss"

import exportComponent from "/builds/christinandrea/kel1-kedaireka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__